<template>
  <div class="ticket-item">
    <div
      class="ticket-item-img"
      :style="{ backgroundImage: `url('${$setPicSize(info.pic)}')` }"
    ></div>
    <div class="ticket-item-content">
      <p class="ticket-item-title">{{ info.title }}</p>
      <p class="ticket-item-id">{{ +type === 1 ? '订单' : '商品' }}id：{{ info.id }}</p>
      <span :class="{ finish: +info.status === 0 }" class="ticket-item-status">{{
        info.status
      }}</span>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
export default {
  name: 'TicketItem',
  props: ['info', 'type'],
  data() {
    return {
      msg: ''
    }
  },
  methods: {
    $setPicSize(url) {
      // 后台没有返回地址给个默认的
      if (!url) {
        return setPicSize(
          'https://pic4.zhuanstatic.com/zhuanzh/ba6b90b0-6620-41fb-9b64-eb1f6ce34624.png',
          100,
          100
        )
      }
      // 部分后台返回的图片url非法，不做处理直接返回
      const reg = /\.(png|jpg|jpeg|gif)/i
      return reg.test(url) ? setPicSize(url, 300, 200) : url
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
